import React from 'react';
import { Button, IconSvg } from '@utex/ui-kit';
import { getTransparentButtonColor } from '../HeaderButtons/buttonsView';
export var MenuButton = function (props) {
    var view = props.view, openSideMenu = props.openSideMenu;
    return (React.createElement(Button, { view: getTransparentButtonColor(view), isBlured: view !== 'default', shape: "circle", onClick: function (e) {
            e.stopPropagation();
            openSideMenu && openSideMenu();
        }, "aria-label": "menu button", "data-testid": "menu-btn" },
        React.createElement(IconSvg, { src: "menu" })));
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/MenuButton/index.js
// module id = 724
// module chunks = 118